import React from 'react'

import { Container } from './styles'

interface ButtonContentProps {
  color?: string
  title: string | undefined
  fontSize?: string
}

export const ButtonContent = ({
  color,
  title,
  fontSize,
}: ButtonContentProps) => {
  return (
    <Container color={color} fontSize={fontSize}>
      {title}
    </Container>
  )
}
